import React from "react";

export const Navigation = (props) => {
  const { labels, onToggleLang, lang } = props;
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            {labels?.brand || "ROYAL MILK SHOP"}
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                {labels?.features || "Features"}
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                {labels?.about || "About"}
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                {labels?.services || "Services"}
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                {labels?.gallery || "Gallery"}
              </a>
            </li>
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll">
                {labels?.contact || "Contact"}
              </a>
            </li>
            <li>
              <button
                type="button"
                className="btn btn-custom"
                onClick={onToggleLang}
                aria-label="Toggle language"
              >
                {labels?.toggle_to || (lang === "en" ? "اردو" : "EN")}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};


